var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AlcorButton',{staticClass:"max-bage h-fit",class:{disabled: !_vm.token},attrs:{"noColor":""},on:{"click":_vm.onMax}},[_vm._v("MAX")])
}
var staticRenderFns = []

export { render, staticRenderFns }